import { render, staticRenderFns } from "./DialogList.vue?vue&type=template&id=066d486f"
import script from "./DialogList.vue?vue&type=script&lang=js"
export * from "./DialogList.vue?vue&type=script&lang=js"
import style0 from "./DialogList.vue?vue&type=style&index=0&id=066d486f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports